import { callApi } from './config/callApi'

export const historyParticipation = async (userId: number): Promise<any> => {
  const url = `/history-participations/${userId}`

  return callApi({
    method: 'get',
    url,
  })
}
